import { defaultConfig } from '../../../config-env';

function ConfigurationService(defaultConfiguration) {
  function getValueFromSessionStorage(key) {
    let value = sessionStorage.getItem(key);
    if (value) {
      try {
        value = JSON.parse(value);
      } catch (e) {
        console.error(`Failed to parse session value for key '${key}'`);
      }
    }
    return value;
  }

  this.get = function (key) {
    const overriddenValue = getValueFromSessionStorage('configuration_' + key);
    return overriddenValue !== null
      ? overriddenValue
      : defaultConfiguration[key];
  };

  this.set = function (key, value) {
    sessionStorage.setItem('configuration_' + key, JSON.stringify(value));
  };
}

export default new ConfigurationService(defaultConfig);
